import React, { useEffect, useState } from "react";
import SearchableSelect from "../../../components/common/SearchableSelect";
import {
  fetchAdminJson,
  fetchAllPages,
  AdminDisclosureCard,
} from "../settingsHelpers";

export function GeographiesTab({ onContextChange }) {
  const [geos, setGeos] = useState([]);
  const [form, setForm] = useState({ name: "", node_type: "region", parent: "" });
  const [error, setError] = useState("");
  const [createOpen, setCreateOpen] = useState(false);

  const loadGeos = async () => {
    try {
      const data = await fetchAllPages("/api/crm/geographies/");
      setGeos(data);
    } catch(err) { setError(err.message); }
  };

  useEffect(() => { loadGeos(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      setError("");
      const payload = {
        name: form.name,
        node_type: form.node_type,
      };
      if (form.parent) {
        payload.parent = form.parent || null;
      }
      await fetchAdminJson("/api/crm/geographies/", {
        method: "POST",
        body: JSON.stringify(payload)
      });
      setForm({ name: "", node_type: form.node_type, parent: "" });
      await loadGeos();
      onContextChange?.();
    } catch(err) { setError(err.message); }
  };

  return (
    <div className="settings-stack">
      {error && <div className="message-banner error">{error}</div>}
      <AdminDisclosureCard
        title="Add Geography Node"
        description="Add regions, cities, zones, and localities without exposing the form by default."
        actionLabel="Open Form"
        open={createOpen}
        onToggle={() => setCreateOpen((current) => !current)}
      >
        <form className="form-grid settings-form-card-inner" onSubmit={handleCreate}>
          <label className="field-stack">
            <span>Name</span>
            <input required value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} />
          </label>
          <label className="field-stack">
            <span>Node Type</span>
            <select value={form.node_type} onChange={(e) => setForm({...form, node_type: e.target.value})}>
              <option value="region">Region</option>
              <option value="city">City</option>
              <option value="zone">Zone</option>
              <option value="locality">Locality</option>
            </select>
          </label>
          <label className="field-stack">
            <span>Parent Geography</span>
            <SearchableSelect
              value={form.parent}
              onChange={(v) => setForm({ ...form, parent: v })}
              options={geos.map((g) => ({ value: String(g.id), label: `${g.name} (${g.node_type})` }))}
              placeholder="None (Top Level)"
            />
          </label>
          <div className="full-span settings-form-card-actions">
            <button className="primary-button" type="submit">Create Node</button>
          </div>
        </form>
      </AdminDisclosureCard>

      <div className="settings-card settings-table-card">
        <div className="settings-card-header">
          <div>
            <p className="login-kicker">Geographies</p>
            <h3>Configured Geography Tree</h3>
          </div>
          <span className="agent-badge mint">{geos.length} nodes</span>
        </div>
        <div className="table-scroll report-table-scroll">
        <table className="report-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Type</th>
              <th>Parent</th>
            </tr>
          </thead>
          <tbody>
            {geos.map(g => (
              <tr key={g.id}>
                <td>{g.id}</td>
                <td>{g.name}</td>
                <td><span className="agent-badge violet">{g.node_type}</span></td>
                <td>
                  {g.parent
                    ? (geos.find((p) => String(p.id) === String(g.parent))?.name || g.parent)
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      </div>
    </div>
  );
}

export default GeographiesTab;
